import React, { FC, useCallback, ChangeEventHandler } from 'react'
import { useController } from 'react-hook-form'
import { Slider } from '@wmgtech/legato'
import { FormSliderProps } from './form-slider.props'

export const FormSlider: FC<FormSliderProps> = ({ fieldName, onChange, children }) => {
  const { field } = useController({ name: fieldName })

  const changeHandler = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      field.onChange(event)
      onChange()
    },
    [field, onChange]
  )

  return (
    <div className="table-row-actions-slider table-row-actions__item">
      <Slider colorTypeOn="secondary-black" label={children} size="xs" checked={field.value} onChange={changeHandler} />
    </div>
  )
}
